import {sendPetition} from '../../js/scripts'

var state = {
	coursesList: [],
	coursesLoading: true
}

var getters = {
	coursesList: state => state.coursesList,
	coursesLoading: state => state.coursesLoading
}

var actions = {
	loadCourses({ commit }, url){
		commit('setCoursesLoading', true)
		sendPetition(
			url,
			(data)=>{
				commit('setCoursesList', data.courses);
				sessionStorage.setItem('courses_list', JSON.stringify(data.courses));
				commit('setCoursesLoading', false)
			}
		)
		
	},
	fillCourses({ commit }, list){
		commit('setCoursesList', list);
		commit('setCoursesLoading', false)
	}
}

var mutations = {
	setCoursesList (state, list) {
		state.coursesList = list;
	},
	setCoursesLoading(state, value){
		state.coursesLoading = value;
	}
}


export var courses = {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}